/* eslint-disable array-callback-return */
/* eslint-disable class-methods-use-this */
import React, { useState, useEffect } from 'react';
import { withRouter } from 'react-router';
import ErrorMessages from '../Errors/ErrorMessages';
import * as AppConstants from '../AppConstants';
import { useSelector } from 'react-redux';

const ErrorHandler = ({ history, children }) => {
  const [hasError, setHasError] = useState(false);
  const [errorMsg, setErrorMsg] = useState('');

  const storedUserAuthRoutes = useSelector(
    (state) => state?.sharedState?.SharedReducer?.storedUserAuthRoutes
  );
  const loginStateStoreObj = useSelector(
    (state) => state?.sharedState?.SharedReducer?.loginStateStoreObj
  );

  // const splitPath = (path) => {
  //   const parts = path.split('/');

  //   if (parts.length === 1) {
  //     return [path];
  //   } else {
  //     const pathName = parts.slice(0, -1).join('/');
  //     return pathName;
  //   }
  // };

  // const checkAccessibility = (pathname) => {
  //   // const userState = JSON.parse(localStorage.getItem('loginState'));
  //   const userState = loginStateStoreObj;
  //   let returnFlag = true;
  //   const declaredAccessibleRoutes =
  //     userState?.accessibleRoutes || storedUserAuthRoutes?.accessibleRoutes;
  //   const pathNameUpdated = splitPath(pathname);
  //   if (declaredAccessibleRoutes && declaredAccessibleRoutes.length > 0) {
  //     Object.keys(declaredAccessibleRoutes).map((value) => {
  //       if (declaredAccessibleRoutes[value]?.indexOf(pathNameUpdated) > -1) {
  //         returnFlag = false;
  //       }
  //     });
  //   }
  //   return returnFlag;
  // };
  const splitPath = (path) => {
    const parts = path.split('/');
    const originalPath = parts[0]; // Consider only the first part as the original path
    return [originalPath];
  };

  const checkAccessibility = (pathname) => {
    const userState = loginStateStoreObj;
    let returnFlag = true;
    const declaredAccessibleRoutes =
      userState?.accessibleRoutes || storedUserAuthRoutes?.accessibleRoutes;
    const originalPath = splitPath(pathname)[0]; // Get the original path

    if (declaredAccessibleRoutes && declaredAccessibleRoutes.length > 0) {
      returnFlag = declaredAccessibleRoutes.includes(originalPath);
    }
    return returnFlag;
  };

  useEffect(() => {
    const unlisten = history.listen((location, action) => {
      if (!checkAccessibility(location.pathname)) {
        setHasError(false);
      } else {
        setHasError(true);
        setErrorMsg("You don't have permission to access this page.");
      }
    });

    return () => unlisten();
  }, [loginStateStoreObj]);

  useEffect(() => {
    if (history.location.pathname) {
      if (!checkAccessibility(history.location.pathname)) {
        setHasError(false);
      } else {
        setHasError(true);
        setErrorMsg("You don't have permission to access this page.");
      }
    }
  }, [storedUserAuthRoutes, loginStateStoreObj]);

  if (hasError && errorMsg) {
    return (
      <div className='pos-relative w-100 h-100'>
        <ErrorMessages errorMessages={[errorMsg]} />
      </div>
    );
  }

  if (hasError && !errorMsg) {
    return (
      <div className='pos-relative w-100 h-100'>
        <ErrorMessages errorMessages={[AppConstants.ERR_PROCESSING_REQ]} />
      </div>
    );
  }

  return children;
};

export default withRouter(ErrorHandler);
